import 'floating-vue/dist/style.css';
import 'intro.js/minified/introjs.min.css';

import { VTooltip, Tooltip, Dropdown, Menu } from 'floating-vue';

import clickOutside from '../directives/click-outside';

/**
 * Global directives and components the shared UI relies on.
 *
 * @param {import('vue').App} app
 * @returns {import('vue').App}
 */
export const installUi = (app) => {
	return app
		.directive('click-outside', clickOutside)
		.directive('tooltip', VTooltip)
		.component('VTooltip', Tooltip)
		.component('VDropdown', Dropdown)
		.component('VMenu', Menu);
};
